module.exports = __webpack_public_path__ + "static/img/zs005.45c4491.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zs005.jpg
// module id = +S5D
// module chunks = 13